// En TaskDetailModal.jsx
import React, { useState, useRef, useEffect } from "react";
import Modal from "react-modal";
import moment from "moment";
import Swal from "sweetalert2";
import { useTaskContext } from "../context/TaskContext";
import Avatar from "../components/Avatar";
import { useAuth } from "../context/AuthContext";

const TaskDetailModal = ({
  isOpen,
  onRequestClose,
  selectedTask, // Este viene de afuera
  customStyles2,
}) => {
  const [localTask, setLocalTask] = useState(null); // <-- Estado local de la tarea
  const [comment, setComment] = useState("");
  const [editCommentIndex, setEditCommentIndex] = useState(-1);
  const [editedComment, setEditedComment] = useState("");
  const editCommentRef = useRef(null);

  const { updateTask } = useTaskContext();
  const { user } = useAuth(); // para obtener el uid real

  useEffect(() => {
    // Cada vez que cambie selectedTask o se abra el modal,
    // copiamos su contenido al localTask
    if (selectedTask && isOpen) {
      setLocalTask({ ...selectedTask });
    }
  }, [selectedTask, isOpen]);

  if (!localTask) return null;

  const formatDate = (ts) => {
    if (!ts) return "";
    return moment(ts).format("DD MMM YYYY HH:mm");
  };

  const handleAddComment = async () => {
    if (!comment.trim()) return;
    // Crea el objeto comentario
    const newComment = {
      text: comment,
      userName: user.displayName,   // o localTask.userName
      userId: user.uid,             // <-- aquí metes el ID real
      timestamp: new Date().toISOString(),
    };
    // Actualiza la tarea en Firestore
    const updatedComments = [...(localTask.comments || []), newComment];
    await updateTask(localTask.id, { comments: updatedComments });

    // Actualiza también la copia local para ver el cambio inmediato
    setLocalTask({
      ...localTask,
      comments: updatedComments,
    });

    setComment("");
    Swal.fire({
      title: "Comentario agregado",
      icon: "success",
      scrollbarPadding: false,
    });
  };

  const handleEditCommentToggle = (index) => {
    setEditCommentIndex(index);
    setEditedComment(localTask.comments[index].text);
  };

  const handleSaveEditedComment = async (index) => {
    const updatedComments = [...localTask.comments];
    updatedComments[index] = {
      ...updatedComments[index],
      text: editedComment,
      timestamp: new Date().toISOString(),
    };

    await updateTask(localTask.id, { comments: updatedComments });
    setLocalTask({
      ...localTask,
      comments: updatedComments,
    });
    setEditCommentIndex(-1);
    setEditedComment("");
  };

  const handleDeleteComment = async (index) => {
    const updatedComments = localTask.comments.filter((_, i) => i !== index);
    await updateTask(localTask.id, { comments: updatedComments });
    setLocalTask({
      ...localTask,
      comments: updatedComments,
    });
    Swal.fire({
      title: "Comentario eliminado",
      icon: "success",
      scrollbarPadding: false,
    });
  };

  const handleCancelEdit = () => {
    setEditCommentIndex(-1);
    setEditedComment("");
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles2}
      contentLabel="Detalles de la Tarea"
    >
      <div className="modal-header">
        <button className="modal-close" onClick={onRequestClose}>
          <i className="bi bi-x-lg"></i>
        </button>
      </div>

      <div className="task-details">
        <div className="user-comment-container">
          <div className="user">
          <Avatar
            userId={localTask.userId}
            size={40}
            className="comment-avatar"
          />
            <div className="user-info">
              <div className="name">{localTask.userName}</div>
              <div className="time">{formatDate(localTask.date)}</div>
            </div>
          </div>

          <div className="comments-container">
            <h4 style={{ fontFamily: "Montserrat, sans-serif" }}>
              Comentarios:
            </h4>
            {localTask.comments && localTask.comments.length > 0 ? (
              localTask.comments.map((c, index) => (
                <div key={index} className="comment">
                  <div className="user">
                  <Avatar
                    userId={c.userId}
                    size={32}
                    className="comment-avatar"
                  />
                    <div className="name">{c.userName}</div>
                    <div className="time">{formatDate(c.timestamp)}</div>
                  </div>
                  {editCommentIndex === index ? (
                    <input
                      type="text"
                      value={editedComment}
                      onChange={(e) => setEditedComment(e.target.value)}
                      className="custom-input"
                      ref={editCommentRef}
                    />
                  ) : (
                    <div className="comentario">{c.text}</div>
                  )}
                  {editCommentIndex === index ? (
                    <div className="comment-buttons-container">
                      <button
                        className="comment-button"
                        onClick={() => handleSaveEditedComment(index)}
                      >
                        Guardar
                      </button>
                      <button
                        className="comment-button"
                        onClick={handleCancelEdit}
                      >
                        Cancelar
                      </button>
                    </div>
                  ) : (
                    <div className="comment-buttons-container">
                      <button
                        className="comment-button"
                        onClick={() => handleEditCommentToggle(index)}
                      >
                        Editar
                      </button>
                      <button
                        className="comment-button"
                        onClick={() => handleDeleteComment(index)}
                      >
                        Eliminar
                      </button>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p>No hay comentarios.</p>
            )}

            <div className="write-comment">
              <input
                type="text"
                placeholder="Haz un comentario..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleAddComment();
                }}
              />
              <button className="send-button" onClick={handleAddComment}>
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TaskDetailModal;